const XIcon = ({className, width, height}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="none"
    width={width}
    height={height}
    role="img"
    aria-label={"x icon"}
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16.5 5.5-11 11m0-11 11 11"
    />
  </svg>
);
export default XIcon;
